import { IconNames } from '@blueprintjs/icons';
import { ReferentPriceTypes } from '@strata/constants';
import { SecondaryData } from '@strata/react-grid';
import { formatRateString } from '@strata/react-servicing-rate';
import { Icon } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

export const RouteSimulationCell = ({
    routeName = undefined,
    simulationErrorMessage = undefined,
    simulationSupplierNpi = undefined,
    simulationOfferRate = undefined,
    simulationReferentPriceType = undefined,
    preBidSupplierNpi = undefined,
    preBidRate = undefined,
    preBidReferentPriceType = undefined,
    backstopSupplierNpi = undefined,
    backstopRate = undefined,
    backstopReferentPriceType = undefined,
    supplierMap = undefined,
    // eslint-disable-next-line complexity
}) => (
    <div className="flex__gap--x-small" style={{ alignItems: 'center' }}>
        <SecondaryData
            data={
                routeName ??
                simulationErrorMessage ?? <span className="sds_ellipsis-animation">Simulating</span>
            }
            customTooltipContent={
                routeName ? (
                    <>
                        <div>Route: {routeName}</div>
                        {simulationSupplierNpi && (
                            <div>
                                Supplier: {supplierMap?.[simulationSupplierNpi]?.name} (
                                {simulationSupplierNpi})
                            </div>
                        )}
                        {simulationOfferRate != null && (
                            <div>
                                Rate:{' '}
                                {formatRateString({
                                    bidDecimal: simulationOfferRate,
                                    referentPriceType: simulationReferentPriceType,
                                })}
                            </div>
                        )}
                        {preBidSupplierNpi && (
                            <div>
                                Top Pre-Bid Supplier: {supplierMap?.[preBidSupplierNpi]?.name} (
                                {preBidSupplierNpi})
                            </div>
                        )}
                        {preBidRate != null && (
                            <div>
                                Max Bid:{' '}
                                {formatRateString({
                                    bidDecimal: preBidRate,
                                    referentPriceType: preBidReferentPriceType,
                                })}
                            </div>
                        )}
                        {backstopSupplierNpi && (
                            <div>
                                PLRA Supplier: {supplierMap?.[backstopSupplierNpi]?.name} (
                                {backstopSupplierNpi})
                            </div>
                        )}
                        {backstopRate != null && (
                            <div>
                                PLRA Rate:{' '}
                                {formatRateString({
                                    bidDecimal: backstopRate,
                                    referentPriceType: backstopReferentPriceType,
                                })}
                            </div>
                        )}
                    </>
                ) : null
            }
        />
        {simulationErrorMessage && (
            <Icon
                icon={IconNames.WARNING_SIGN}
                intent={Icon.Intent.WARNING}
                tooltipContent={simulationErrorMessage}
            />
        )}
    </div>
);

RouteSimulationCell.propTypes = {
    routeName: PropTypes.string,
    simulationErrorMessage: PropTypes.string,
    simulationSupplierNpi: PropTypes.string,
    simulationOfferRate: PropTypes.number,
    simulationReferentPriceType: PropTypes.oneOf(Object.values(ReferentPriceTypes)),
    preBidSupplierNpi: PropTypes.string,
    preBidRate: PropTypes.number,
    preBidReferentPriceType: PropTypes.oneOf(Object.values(ReferentPriceTypes)),
    backstopSupplierNpi: PropTypes.string,
    backstopRate: PropTypes.number,
    backstopReferentPriceType: PropTypes.oneOf(Object.values(ReferentPriceTypes)),
    supplierMap: PropTypes.objectOf(
        PropTypes.shape({
            name: PropTypes.string,
            networkStatus: PropTypes.string,
            parentSupplierNpi: PropTypes.string,
            children: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
};
